import type { AccountData } from '../../../api';

// Mirror of the backend booking fee (api logic/pricing/booking_fee.py), pinned by the shared fixture test.

export const isBookingFeeOn = (account?: AccountData): boolean =>
  !!account?.booking_fee?.enabled && !!account.booking_fee.available;

export const bookingFeeCents = (amountCents: number, ratePercent: number): number => {
  const rateMilli = Math.round(ratePercent * 1000);
  return Math.floor((amountCents * rateMilli + 50000) / 100000);
};

export const bookingFeeAmount = (amount: number, account?: AccountData): number => {
  if (!isBookingFeeOn(account) || amount <= 0) {
    return 0;
  }
  return bookingFeeCents(Math.round(amount * 100), account?.booking_fee?.rate_percent ?? 0) / 100;
};

export const withBookingFee = (amount: number, account?: AccountData): number => {
  if (!isBookingFeeOn(account)) {
    return amount;
  }
  return Math.round((amount + bookingFeeAmount(amount, account)) * 100) / 100;
};
